import React from 'react';
import { useTranslation } from 'react-i18next';
import './CronTaskHistory.css';
import ReactTooltip from "react-tooltip";

const CronTaskHistory = ({ history }) => {
    const { t } = useTranslation();

    if (!history?.length)
        return null;

    const total = history.reduce((acc, interval) => acc + interval.nb, 0);

    const describe = interval => {
        return t('cron_tasks.interval_description', {
            nb: interval.nb,
            from: interval.from.format('LLL'),
            to: interval.to.format('LLL'),
            status: t(`cron_tasks.status_${interval.status}`)
        });
    };

    return (
        <div className="CronTaskHistory">
            <div className="history-bar">
                {history.toReversed().map((interval, index) => (
                    <div
                        key={index}
                        data-tooltip={ describe(interval) }
                        className={`interval ${interval.status}`}
                        style={{width: `${interval.nb / total * 100}%`}}
                    >
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CronTaskHistory;
